import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, ExternalLink, Factory, Github, ShoppingBag } from "lucide-react";
import api from "../lib/api";
import { displayBusinessName, displayProductText as displayText } from "../lib/productNames";
import TopBar from "../components/TopBar";
import EmptyState from "../components/EmptyState";

const HEALTH_TONE = { AT_RISK: "red", WATCH: "amber", BUILDING: "blue", HEALTHY: "green", UNKNOWN: "dim" };
const STATUS_TONE = { ACTIVE: "green", INCUBATING: "purple", ARCHIVED: "dim" };
const businessRoute = (key) => key === "gearlinc" ? "/gearlinc" : key === "linkforge" ? "/linkforge" : `/businesses/${key}`;
const displayName = (b) => displayBusinessName(b);

function BusinessName({ name }) {
  const idx = name.toLowerCase().lastIndexOf("linc");
  if (idx === -1) return <>{name}</>;
  return <>{name.slice(0, idx)}<span className="linc">{name.slice(idx, idx + 4)}</span>{name.slice(idx + 4)}</>;
}

export default function BusinessesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => { try { const { data } = await api.get("/businesses"); setItems(data); } finally { setLoading(false); } })(); }, []);

  return (
    <div data-edit-name="Businesses">
      <TopBar title="Businesses" subtitle="Ventures and products operated through LincWerks." />
      {loading ? null : items.length === 0 ? (
        <div className="panel"><div className="panel-body"><EmptyState title="No businesses yet." icon={Briefcase} /></div></div>
      ) : (
        <div className="grid-2" data-testid="businesses-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))", gap: 14 }}>
          {items.map((b) => {
            const key = b.key || b.slug;
            const Icon = key === "linkforge" ? Factory : key === "gearlinc" ? ShoppingBag : Briefcase;
            const name = displayName(b);
            return (
              <div className="panel" key={key} data-testid={`biz-card-${key}`} data-edit-name={name}>
                <div className="panel-head"><div><h2 style={{ marginBottom: 4, display:"flex", alignItems:"center", gap:7 }}><Icon size={15} /><BusinessName name={name} /></h2><p className="hint" style={{ fontSize: 11 }}><span className={`pill ${STATUS_TONE[b.status] || "dim"}`}>{b.status}</span>{" "}<span className="pill dim">{b.business_type?.replace(/_/g, " ")}</span></p></div><span className={`pill ${HEALTH_TONE[b.health] || "dim"}`}>{b.health}</span></div>
                <div className="panel-body"><p style={{ fontSize: 13, opacity: 0.85, marginBottom: 10 }}>{displayText(b.description)}</p>{b.current_milestone ? <p><small className="hint">CURRENT MILESTONE</small><br /><b>{displayText(b.current_milestone)}</b></p> : null}{b.target_date ? <p style={{ marginTop: 8 }}><small className="hint">TARGET</small>{" "}<span className="mono">{b.target_date}</span></p> : null}<div style={{ display: "flex", gap: 8, marginTop: 14, flexWrap: "wrap" }}><Link className="btn small primary" to={businessRoute(key)} data-testid={`biz-open-${key}`}>{key === "gearlinc" || key === "linkforge" ? "Open workspace" : "Open detail"}</Link>{b.github?.repo_url ? <a href={b.github.repo_url} target="_blank" rel="noreferrer" className="btn small"><Github size={12} /> Repo <ExternalLink size={10} /></a> : <span className="pill dim" style={{ opacity: 0.6 }}>no repo yet</span>}</div></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
